/* Kinde — interacciones mínimas: menú móvil + galería de producto.
   Sin dependencias. Las animaciones son 100% CSS. */
(function () {
  'use strict';

  /* ── menú móvil ─────────────────────────────────────────────── */
  var burger = document.querySelector('[data-k-burger]');
  var mobilenav = document.querySelector('[data-k-mobilenav]');
  if (burger && mobilenav) {
    burger.addEventListener('click', function () {
      var open = mobilenav.hasAttribute('data-open');
      if (open) {
        mobilenav.removeAttribute('data-open');
        mobilenav.hidden = true;
        burger.setAttribute('aria-expanded', 'false');
      } else {
        mobilenav.hidden = false;
        mobilenav.setAttribute('data-open', '');
        burger.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ── galería de producto: miniatura → imagen principal ──────── */
  var main = document.querySelector('[data-k-gallery-main]');
  if (main) {
    document.querySelectorAll('[data-k-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var img = main.querySelector('img');
        if (full && img) {
          img.src = full;
          img.srcset = '';
        }
      });
    });
  }
})();
